// import React, { Component, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import footerdata from '../../data/footerdata.json';

// const Footer_v1 = () => {

//   useEffect(() => {
//     let publicUrl = process.env.PUBLIC_URL + '/'
//     const minscript = document.createElement("script");
//     minscript.async = true;
//     minscript.src = publicUrl + "assets/js/main.js";

//     document.body.appendChild(minscript);

//   }, [])

//   let publicUrl = process.env.PUBLIC_URL + '/'
//   let imgattr = "Footer logo"
//   const inlineStyle = {
//     backgroundImage: 'url(' + publicUrl + footerdata.footerbg + ')'
//   }

//   //   const handleSubmit = () => {
//   // alert('hgjhgjhgjh')
//   //   }

//   return (
//     <footer className="footer-area">
//       <div className="container">
//         <div className="footer-top">
//           <div className="row">
//             <div className="col-sm-4" style={{ marginTop: "-25px" }}>
//               <a className="footer-logo" href="/" ><img src={publicUrl + footerdata.footerlogo} alt={imgattr} /></a>
//             </div>
//             <div className="col-sm-8">
//               <div className="footer-social text-sm-right">
//                 <span>FOLLOW US</span>
//                 <ul className="social-icon">
//                   <li >
//                     <a href="https://www.facebook.com/profile.php?id=61574452610932 " target="_blank"><i className="fa fa-facebook" /></a>
//                     <a href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09" target="_blank"><img src='/icons8-x-50.png' style={{ width: "15px", marginTop: "-5px" }} alt='' /></a>
//                     <a href="https://www.linkedin.com/company/trinest-sky-real-estate/" target="_blank"><i className="fa fa-linkedin" /></a>
//                     <a href="https://www.instagram.com/trinestsky/" target="_blank"><i className="fa fa-instagram" /></a>
//                      <a href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg" target="_blank"><i class="fa-brands fa-youtube"></i></a>
//                         <a href="https://www.tiktok.com/@trinestsky?is_from_webapp=1&sender_device=pc" target="_blank"><i class="fa-brands fa-tiktok"></i></a>
//                   </li>
//                   {/* <img src='assets/img/tiktok.png' style={{ width: "40px", borderRadius: "50%"}}></img> */}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="footer-bottom">
//           <div className="row">
//             <div className="col-lg-4 col-sm-6">
//               <div className="widget widget_nav_menu">
//                 <h4 className="widget-title">{footerdata.popularserces.title}</h4>
//                 <ul>
//                   {footerdata.popularserces.links.map((item, i) =>
//                     <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
//                   )}

//                 </ul>
//               </div>
//             </div>
//             <div className="col-lg-5 col-sm-6">
//               <div className="widget widget_nav_menu">
//                 <h4 className="widget-title">{footerdata.Homepress.title}</h4>
//                 <ul>
//                   {footerdata.Homepress.links.map((item, i) =>
//                     <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//             <div className="col-lg-3 col-sm-6">
//               <div className="widget widget_nav_menu">
//                 <h4 className="widget-title">{footerdata.quicklink.title}</h4>
//                 <ul>
//                   {footerdata.quicklink.links.map((item, i) =>
//                     <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//             {/* <div className="col-lg-3 col-sm-6">
//               <div className="widget widget-subscribe" >
//                 <div className="rld-single-input">
//                   <input type="text" name="name" placeholder="Full Name" />
//                 </div>
//                 <div className="rld-single-input">
//                   <input type="text" name="email" placeholder="Your@email.com" />
//                 </div>
//                 <button onClick={handleSubmit} className="btn btn-yellow w-100">Subscribe</button>
//               </div>
//             </div> */}
//           </div>
//         </div>
//         <div className="copy-right text-center" dangerouslySetInnerHTML={{ __html: footerdata.copyrighttext }}></div>
//       </div>
//     </footer>

//   )

// }


// export default Footer_v1









import React from 'react';
import { Link } from 'react-router-dom';
import footerdata from '../../data/footerdata.json';
import { useState } from 'react';

const Footer_v1 = () => {
  const publicUrl = process.env.PUBLIC_URL + '/';
  const minscript = document.createElement("script");
  minscript.async = true;
  minscript.src = publicUrl + "assets/js/main.js"
  document.body.appendChild(minscript);

  const sections = [
    { key: 'popularserces' },
    { key: 'sitemap' },
    { key: 'dubaimarkets' },
    { key: 'Homepress' },
    { key: 'quicklink' },
    { key: 'aboutcompany' },
  ];

  const containerStyle = {
    backgroundColor: "#f4f7fb",
    color: '#333',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "40px 0 0",
    boxShadow: "0 -2px 10px rgba(0,0,0,0.05)"
  };

  const logoStyle = {
    maxWidth: '340px',
    marginBottom: '20px',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
  };

  const sectionTitleStyle = {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#2c3e50',
    position: 'relative',
    paddingBottom: '8px'
  };

  const sectionTitleAfterStyle = {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '40px',
    height: '2px',
    backgroundColor: '#fda94f'
  };

  const linkStyle = {
    color: '#555',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'all 0.7s ease',
    display: 'block',
    padding: '6px 0',
    lineHeight: '1.4'
  };

  const linkHoverStyle = {
    color: '#fda94f',
    // transform: 'translateX(5px)'
  };
  const linkHoverLeave = {
    color: '#555',
    // transform: 'translateX(-5px)'
  };

  const linkHoverStyleP = {
    color: '#fda94f',
    transform: 'translatey(-3px)'
  };
  const linkHoverLeaveP = {
    color: '#555',
    transform: 'translatey(3px)'
  };

  const socialIconStyle = {
    fontSize: '16px',
    color: '#fc7319',
    marginRight: '16px',
    transition: 'all 0.3s ease',
    backgroundColor: '#f1f1f1',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const socialIconHoverStyle = {
    color: '#fff',
    backgroundColor: '#fda94f',
    transform: 'translateY(-3px)'
  };
  const socialIconHoverStyLeave = {
    color: '#fc7319',
    backgroundColor: '#f1f1f1',
    transform: 'translateY(0px)'
  };

  const googleBtnStyle = {
    backgroundColor: '#f88f3c',
    color: 'white',
    borderRadius: '8px',
    padding: '12px 24px',
    fontWeight: '500',
    display: 'inline-flex',
    alignItems: 'center',
    margin: '30px 0',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    textTransform: 'uppercase',
    fontSize: '14px'
  };

  const googleBtnHoverStyle = {
    backgroundColor: '#e67e22',
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 8px rgba(0,0,0,0.15)'
  };
  const googleBtnHoverStyleLeave = {
    backgroundColor: '#f88f3c',
    transform: 'translateY(0px)',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  };

  const footerBottomStyle = {
    borderTop: '1px solid #e1e1e1',
    padding: '20px 0',
    marginTop: '30px',
    fontSize: '14px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#777'
  };

  const imgattr = "Footer logo";
  const [isHovered, setIsHovered] = useState(false);
  return (
    <footer style={containerStyle}>
      <div className="container">
        {/* Top Logo and Social */}
        <div className="footer-top" style={{ marginBottom: '40px' }}>
          <div className="row align-items-center">
            <div className="col-md-4 mb-4 mb-md-0">
              <a className="footer-logo" href="/">
                <img
                  src={publicUrl + footerdata.footerlogo}
                  alt={imgattr}
                  style={logoStyle}
                />
              </a>
              {/* <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6' }}>
                Connecting you to the best properties in Dubai.
              </p> */}
            </div>
            <div className="col-md-8">
              <div className="footer-social" style={{ textAlign: 'right' }}>
                <span style={{
                  display: 'inline-block',
                  marginRight: '15px',
                  color: '#555',
                  fontWeight: '500'
                }}>
                  <p className="follow-label">FOLLOW US</p>
                </span>
                <ul className="social-icon" style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  display: 'inline-block'
                }}>
                  <li style={{ display: 'inline-block' }}>
                    <a
                      href="https://www.facebook.com/profile.php?id=61574452610932"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                    >
                      <i className="fa fa-facebook" />
                    </a>
                    <a
                      href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >


                      {isHovered ? (
                        <img
                          src='/twitterWhite.png'
                          style={{ width: "15px" }}
                          alt='X (Twitter)'
                        />
                      ) : (
                        <img
                          src='/icons8-x-50.png'
                          style={{ width: "15px" }}
                          alt='X (Twitter)'
                        />
                      )}

                    </a>
                    <a
                      href="https://www.linkedin.com/company/trinest-sky-real-estate/"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                    >
                      <i className="fa fa-linkedin" />
                    </a>
                    <a
                      href="https://www.instagram.com/trinestsky/"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                    >
                      <i className="fa fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                    >
                      <i className="fa-brands fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@trinestsky?is_from_webapp=1&sender_device=pc"
                      target="_blank"
                      rel="noreferrer"
                      style={socialIconStyle}
                      onMouseOver={e => Object.assign(e.currentTarget.style, socialIconHoverStyle)}
                      onMouseOut={e => Object.assign(e.currentTarget.style, socialIconHoverStyLeave)}
                    >
                      <i className="fa-brands fa-tiktok" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Link Columns */}
        <div className="row">
          {sections.map((section, idx) => {
            const data = footerdata[section.key];
            return (
              <div className="col-6 col-md-4 col-lg-2 mb-5" key={idx}>
                <div style={{ ...sectionTitleStyle }}>
                  {data.title}
                  <span style={sectionTitleAfterStyle}></span>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {data.links.map((link, i) => (
                    <li key={i}>
                      {link.url.startsWith('http') ? (
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noreferrer"
                          style={linkStyle}
                          onMouseOver={e => Object.assign(e.currentTarget.style, linkHoverStyle)}
                          onMouseOut={e => Object.assign(e.currentTarget.style, linkHoverLeave)}
                        >
                          {link.title}
                        </a>
                      ) : (
                        <Link
                          to={link.url}
                          style={linkStyle}
                          onMouseOver={e => Object.assign(e.currentTarget.style, linkHoverStyle)}
                          onMouseOut={e => Object.assign(e.currentTarget.style, linkHoverLeave)}
                        >
                          {link.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Google My Business */}
        {/* <div className="text-center">
          <a
            href="https://www.google.com/maps/place/TRINEST+SKY+REAL+ESTATE/@25.208963,55.272498,16z/data=!4m8!3m7!1s0x6702e02ed9d5d273:0xd0b8d09c671ca8c0!8m2!3d25.2089625!4d55.2724984!9m1!1b1!16s%2Fg%2F11m6h_57jk?hl=en&entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D "
            target="_blank"
            rel="noreferrer"
            style={googleBtnStyle}
            onMouseOver={e => Object.assign(e.currentTarget.style, googleBtnHoverStyle)}
            onMouseOut={e => Object.assign(e.currentTarget.style, googleBtnHoverStyleLeave)}
          >
            <i className="fa fa-google me-2" style={{ marginRight: '10px' }}></i>
            Google Reviews
          </a>
        </div> */}
        <div className='row g-3'>
          {/* Map Column - Full width on mobile, 2/3 on larger screens */}
          <div className='col-12 col-lg-8'>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.08)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.829631009257!2d55.26992347394876!3d25.208967331226575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6702e02ed9d5d273%3A0xd0b8d09c671ca8c0!2sTRINEST%20SKY%20REAL%20ESTATE!5e0!3m2!1sen!2sin!4v1747805591863!5m2!1sen!2sin"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0
                }}
                allowFullScreen
                aria-label="Trinest Sky Real Estate Location Map"
                loading="lazy"
              />
            </div>
          </div>

          {/* Reviews Column - Full width on mobile, 1/3 on larger screens */}
          <div className='col-12 col-lg-4 d-flex'>
            <div className="text-center w-100" style={{
              padding: '25px',
              backgroundColor: '#f4f7fb',
              borderRadius: '12px',
              maxWidth: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              {/* Reviews Section */}
              <div style={{
                marginBottom: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span style={{
                  fontSize: 'clamp(16px, 2vw, 18px)',
                  fontWeight: '700',
                  color: '#2c3e50',
                  textTransform: 'uppercase',
                  letterSpacing: '1.2px',
                  marginBottom: '5px'
                }}>Customer Reviews</span>

                {/* Star Rating */}
                <div style={{
                  color: '#fc7319',
                  fontSize: 'clamp(22px, 3vw, 28px)',
                  letterSpacing: '4px',
                  lineHeight: '1',
                  transition: 'all 0.3s ease',
                  transform: 'scale(1)'
                }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                >
                  ★★★★★
                </div>

                <span style={{
                  fontSize: 'clamp(14px, 2vw, 15px)',
                  color: '#7f8c8d',
                  marginTop: '8px',
                  fontWeight: '500'
                }}>
                  <span style={{ color: '#2c3e50', fontWeight: '600' }}></span> Verified Reviews
                </span>
              </div>

              {/* Google Reviews Button */}
              <a
                href="https://www.google.com/search?q=trinest+sky+real+estate&sca_esv=6a136238722af36a&sxsrf=%3A1752669968854&ei=EJ93aIG8M4yVvr0P09GfwA0&gs_ssp=eJzj4tVP1zc0zDXLiDc1z8o2YLRSNagwMzcwSgWiFMsU0xQjc2Mrg4oUgySLFAPLZDNzw-REi2QDL_GSosy81OISheLsSoWi1MQcBSAnsSQVAHiFGAs&oq=trine&gs_lp=Egxnd3Mtd2l6LXNlcnAiBXRyaW5lKgIIADIQEC4YgAQYxwEYJxiKBRivATIQEC4YgAQYQxjHARiKBRivATILEC4YgAQY0QMYxwEyBRAuGIAEMgsQLhiABBjHARivATIKEC4YgAQYQxiKBTIIEAAYgAQYsQMyBRAAGIAEMgsQLhiABBjHARivATIFEAAYgAQyHRAuGIAEGMcBGIoFGK8BGJcFGNwEGN4EGOAE2AEBSOciUPMKWLMTcAF4AZABAJgB0wGgAcMHqgEFMC40LjG4AQHIAQD4AQGYAgegArERqAIPwgIHECMYJxjqAsICDRAuGMcBGCcY6gIYrwHCAhQQABiABBiRAhi0AhiKBRjqAtgBAcICHRAuGIAEGJECGLQCGMcBGMgDGIoFGOoCGK8B2AEBwgIgEC4YgAQYkQIYtAIYxwEYmAUYyAMYigUY6gIYrwHYAQHCAgoQIxiABBgnGIoFwgILEAAYgAQYkQIYigXCAhoQLhiABBiRAhjHARiYBRiZBRiKBRieBRivAcICChAAGIAEGEMYigXCAgsQABiABBixAxiDAcICFBAuGIAEGLEDGNEDGIMBGMcBGIoFwgIOEAAYgAQYsQMYgwEYigXCAhAQABiABBixAxhDGIMBGIoFwgINEC4YgAQYsQMYQxiKBcICDhAuGIAEGMcBGI4FGK8BwgILEC4YgAQYsQMYgwGYAxDxBaDMZ3nn9suyugYGCAEQARgBkgcJMS4yLjMuNy0xoAezZrIHBTAuMi4zuAflB8IHBzAuMS40LjLIByw&sclient=gws-wiz-serp"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#fff',
                  color: 'white',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: 'clamp(14px, 2vw, 16px)',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  textDecoration: 'none',
                  transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                  boxShadow: '0 4px 6px rgba(66, 133, 244, 0.3)',
                  position: 'relative',
                  overflow: 'hidden',
                  margin: '0 auto',
                  maxWidth: '100%'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 7px 14px rgba(66, 133, 244, 0.4)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(66, 133, 244, 0.3)';
                }}
              >
                <img
                  src='/icons8-google-48.png'
                  style={{ width: "30px" }}
                  alt='X (Twitter)'
                />
                {/* <i className="fa fa-google" style={{
                  marginRight: '10px',
                  fontSize: 'clamp(16px, 2vw, 18px)',
                  transition: 'transform 0.3s ease'
                }}></i> */}
                <span style={{ position: 'relative', zIndex: 2, color: "#333" }}>Reviews</span>
                <span style={{
                  position: 'absolute',
                  top: '-50%',
                  left: '-50%',
                  width: '200%',
                  height: '200%',
                  background: 'linear-gradient(rgba(255,255,255,0.3), rgba(255,255,255,0))',
                  transform: 'translateY(100%)',
                  transition: 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)'
                }}></span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={footerBottomStyle}>
          <div
            dangerouslySetInnerHTML={{ __html: footerdata?.copyrighttext }}
            style={{ marginBottom: '10px' }}
          />
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <Link
              to="/privacy"
              style={linkStyle}
              onMouseOver={e => Object.assign(e.currentTarget.style, linkHoverStyleP)}
              onMouseOut={e => Object.assign(e.currentTarget.style, linkHoverLeaveP)}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              style={linkStyle}
              onMouseOver={e => Object.assign(e.currentTarget.style, linkHoverStyleP)}
              onMouseOut={e => Object.assign(e.currentTarget.style, linkHoverLeaveP)}
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer_v1;


